// src/utils/withdrawalStatusLabels.js

export const withdrawalStatusLabels = {
  pending: "En attente de validation",
  approved: "Approuvé par l'admin",
  processing: "Envoyé à Binance",
  completed: "Terminé avec succès",
  rejected: "Rejeté par l'admin",
  failed_by_binance: "Échec Binance (remboursé)",
  failed_internal_error: "Erreur interne"
};

export const withdrawalStatusColors = {
  pending: "#ffa500", // orange
  approved: "#007bff", // blue
  processing: "#17a2b8", // cyan
  completed: "#28a745", // green
  rejected: "#dc3545", // red
  failed_by_binance: "#6f42c1", // purple
  failed_internal_error: "#6c757d" // gray
};